import BlogList from '../BlogList.vue'
import BlogEditor from '../BlogEditor.vue'

export default [
    {
        path: '/admin_blog',
        name: '/admin_blog',
        component: BlogList,
        meta: { layout: 'admin-layout' },
    },
    {
        path: '/admin_blog/new',
        name: '/admin_blog_new',
        component: BlogEditor,
        meta: { layout: 'admin-layout' },
    },
    {
        path: '/admin_blog/:id',
        name: '/admin_blog_edit',
        component: BlogEditor,
        meta: { layout: 'admin-layout' },
    },
]
